import React from 'react';

import T from 'Utilities/texts';

import { TIMELINE_MILESTONES, TIMELINE_RIBBON } from './Timeline.constants';

import styles from './Timeline.scss';

export const Timeline = React.memo(() => (
  <section className={styles.timeline}>
    <h2 className={styles.title}>
      {T.translate('aboutPage.timeline.title')}
    </h2>
    <ol className={styles.milestones} role="list">
      {TIMELINE_MILESTONES.map(({
        imgAvif, imgHeight, imgSrc, imgWebp, imgWidth, year,
      }, index) => {
        const title = String(T.translate(`aboutPage.timeline.milestones.${year}.title`));
        const isLast = index === TIMELINE_MILESTONES.length - 1;

        return (
          <li key={year} className={styles.milestone}>
            <div className={styles.cards}>
              <div className={styles.imageCard}>
                <picture>
                  <source srcSet={imgAvif} type="image/avif" />
                  <source srcSet={imgWebp} type="image/webp" />
                  <img
                    alt={title}
                    className={styles.image}
                    decoding="async"
                    height={imgHeight}
                    loading="lazy"
                    src={imgSrc}
                    width={imgWidth}
                  />
                </picture>
              </div>
              <div className={styles.textCard}>
                <p data-thc-style-override className={styles.year}>{year}</p>
                <p className={styles.body}>
                  {title}
                  {' '}
                  {T.translate(`aboutPage.timeline.milestones.${year}.description`)}
                </p>
              </div>
            </div>
            {!isLast && (
              <img
                alt=""
                aria-hidden="true"
                className={styles.ribbon}
                decoding="async"
                height={TIMELINE_RIBBON.height}
                loading="lazy"
                src={TIMELINE_RIBBON.src}
                width={TIMELINE_RIBBON.width}
              />
            )}
          </li>
        );
      })}
    </ol>
  </section>
));
